export type SiteStatus = '已完成' | 'V2 发布候选' | '筹备中'

export interface SiteEnvironment {
  VITE_SE_UNIVERSE_URL?: string
  VITE_CURRICULUM_ATLAS_URL?: string
  VITE_FRESHMAN_OS_URL?: string
  VITE_SE_DESK_URL?: string
  VITE_FRESHMAN_SIMULATOR_URL?: string
  VITE_SE_ZERO_LAB_URL?: string
  VITE_DEVELOPER_LAB_URL?: string
  VITE_SE_ORIGIN_GALAXY_URL?: string
  VITE_SE_PASSPORT_URL?: string
  DEV?: boolean
}

export interface SeriesSite {
  id: string
  name: string
  english: string
  directory: string
  description: string
  status: SiteStatus
  href: string | null
}

export function createSiteRegistry(environment: SiteEnvironment): readonly SeriesSite[] {
  const universeUrl =
    environment.VITE_SE_UNIVERSE_URL ??
    (environment.DEV ? 'http://127.0.0.1:4173' : '../se-universe/')
  const atlasUrl =
    environment.VITE_CURRICULUM_ATLAS_URL ??
    (environment.DEV ? 'http://127.0.0.1:4174' : '../curriculum-atlas/')
  const freshmanUrl =
    environment.VITE_FRESHMAN_OS_URL ??
    (environment.DEV ? 'http://127.0.0.1:4175' : '../freshman-os/')
  const seDeskUrl =
    environment.VITE_SE_DESK_URL ?? (environment.DEV ? 'http://127.0.0.1:4181' : '../se-desk/')
  const simulatorUrl =
    environment.VITE_FRESHMAN_SIMULATOR_URL ??
    (environment.DEV ? 'http://127.0.0.1:4176' : '../freshman-simulator/')
  const zeroLabRoot =
    environment.VITE_SE_ZERO_LAB_URL ?? (environment.DEV ? 'http://127.0.0.1:4177' : '../zero-lab/')
  const zeroLabUrl = `${zeroLabRoot.split('#')[0] ?? zeroLabRoot}#home`
  const developerLabUrl =
    environment.VITE_DEVELOPER_LAB_URL ??
    (environment.DEV ? 'http://127.0.0.1:4180' : '../developer-lab/')
  const originUrl =
    environment.VITE_SE_ORIGIN_GALAXY_URL ??
    (environment.DEV ? 'http://127.0.0.1:4178' : '../origin/')
  const passportUrl =
    environment.VITE_SE_PASSPORT_URL ?? (environment.DEV ? 'http://127.0.0.1:4179' : '../passport/')

  return [
    {
      id: 'se-universe',
      name: 'SE Universe｜软件工程新生数字宇宙',
      english: 'SE UNIVERSE',
      directory: 'se-universe',
      description: '从软件生命周期、四年成长与方向入口认识软件工程。',
      status: '已完成',
      href: universeUrl,
    },
    {
      id: 'freshman-os',
      name: 'Freshman OS｜大学新生身份迁移系统',
      english: 'FRESHMAN OS',
      directory: 'freshman-os',
      description: '从高中到大学，重新配置时间、信息、关系与求助方式。',
      status: 'V2 发布候选',
      href: freshmanUrl,
    },
    {
      id: 'se-desk',
      name: 'SE Desk｜软件工程新生服务台',
      english: 'SE DESK',
      directory: 'se-desk',
      description: '办事入口、常用电话、公众号和学长经验。',
      status: '已完成',
      href: seDeskUrl,
    },
    {
      id: 'developer-lab',
      name: 'Developer Lab｜开发者工作台启蒙实验室',
      english: 'DEVELOPER LAB',
      directory: 'developer-lab',
      description: '通过六个小实验，认识项目、代码、编译和运行。',
      status: '已完成',
      href: developerLabUrl,
    },
    {
      id: 'se-zero-lab',
      name: 'SE Zero Lab｜软件工程零号实验舱',
      english: 'ZERO LAB',
      directory: 'se-zero-lab',
      description: '先不用记住代码，先看见程序是怎样运行的。',
      status: '已完成',
      href: zeroLabUrl,
    },
    {
      id: 'curriculum-atlas',
      name: 'SE Path｜软件工程四年课程图谱',
      english: 'SE CURRICULUM ATLAS',
      directory: 'curriculum-atlas',
      description: '把四年课程、学分、实践与知识关系连接成一张工程蓝图。',
      status: '已完成',
      href: atlasUrl,
    },
    {
      id: 'freshman-simulator',
      name: 'Freshman Simulator｜大学第一月 AI 互动叙事',
      english: 'FRESHMAN SIMULATOR',
      directory: 'freshman-simulator',
      description: '专业世界已经开启，但你的第一段大学故事还没有发生。',
      status: '已完成',
      href: simulatorUrl,
    },
    {
      id: 'freshman-origin-galaxy',
      name: 'SE Origin Galaxy｜新生来处星系',
      english: 'ORIGIN GALAXY',
      directory: 'freshman-origin-galaxy',
      description: '从不同城市出发，在软件工程的同一坐标相遇。',
      status: '已完成',
      href: originUrl,
    },
    {
      id: 'se-passport',
      name: 'SE Passport｜软件工程新生数字通行证',
      english: 'PASSPORT',
      directory: 'se-passport',
      description: '跨子站连续的个人学习工作台，记录课程进度与实验历程。',
      status: '已完成',
      href: passportUrl,
    },
  ]
}
